/**
 * Universal printing system types
 * All printable documents follow this standardized interface
 */

export interface PrintableDocument {
  lines: string[]
  metadata?: PrintMetadata
}

export interface PrintMetadata {
  /** Number of copies to print */
  copies?: number
  /** Cut paper after printing */
  cut?: boolean
  /** Open cash drawer */
  drawer?: boolean
  /** Business information for header */
  business?: BusinessInfo
  /** Document type for logging */
  type?: 'receipt' | 'report' | 'ticket' | 'other'
}

export interface BusinessInfo {
  name: string
  address?: string
  phone?: string
}

/**
 * Standard formatting widths for thermal printers
 */
export const THERMAL_WIDTH = {
  /** 58mm thermal printer width */
  SMALL: 32,
  /** 80mm thermal printer width */
  LARGE: 48,
} as const

/**
 * Line formatting prefixes for simple ESC/POS formatting
 * Usage: "!B:TOTAL: $150" for bold, "!C:Thank you!" for center
 */
export const LINE_PREFIXES = {
  /** Bold text: !B:text */
  BOLD: '!B:',
  /** Center aligned: !C:text */
  CENTER: '!C:',
  /** Large text: !L:text */
  LARGE: '!L:',
  /** Bold + Center + Large (for headers): !H:text */
  HEADER: '!H:',
  /** QR code: !QR:data */
  QR: '!QR:',
} as const

/**
 * Parsed line with formatting information
 */
export interface ParsedLine {
  text: string
  bold?: boolean
  center?: boolean
  large?: boolean
}
